import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetCycleSummaryDiffResponse = {
  OrderCode: string;
  CatalogId: string;
  Plan: number;
}[];

/**
 * サイクル設定予実変更差分取得サービス
 * @export GetCycleSummaryDiffService
 * @class GetCycleSummaryDiffService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCycleSummaryDiffService extends PlessJsonResponderSub<GetCycleSummaryDiffResponse> {
  model: KYMW1200Model;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCycleSummaryDiffService
   */
  private getBody(): PlessRequest {
    const catalogs: {
      parameter: {
        MediumType: string;
        PCode: string;
        OrderCode: string;
        PricePattern: string;
      };
    }[] = [];
    this.model.updateItemInfosPerCatalog.forEach(_u => {
      this.model.getUpdatedCatalogIds(_u).forEach(_i => {
        catalogs.push({
          parameter: {
            MediumType: _u.mediumType,
            PCode: _u.pcode,
            OrderCode: _i,
            PricePattern: _u.catalogInfoMap[_i].pricePattern,
          },
        });
      });
    });

    return new PlessRequest({
      search: {
        CycleOrderInfo: {
          combination: catalogs,
        },
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetCycleSummaryDiffService
   */
  execute(
    model: KYMW1200Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.model.summaryList.forEach(_s => (_s.planDiff = null));
    this.succeed = s;
    this.fail = f;
    this.send('getCycleSummaryDiff', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCycleSummaryDiffService
   */
  success(data: GetCycleSummaryDiffResponse) {
    data.forEach(_d => {
      let val = Number(_d.Plan);
      if (Number.isNaN(val)) val = 0;
      this.model.summaryList.find(
        _s => _d.OrderCode === _s.orderCode
      ).planDiff = val;
    });
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW1200Model): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
